module.exports = __webpack_public_path__ + "media/images/badge__ces-editors-choice-e690a86eb31823db23fb7f1ac91ea8ce.svg";